
const state = {
  loading: false,
  titleBreadcrumb: 'Nova campanha',
}
const mutations = {
  'TOGGLE_LOADING_BREADCRUMB' (state, payload = false) {
    state.loading = !!payload
  },
  'SET_TITLE_BREADCRUMB' (state, payload) {
    state.titleBreadcrumb = payload
  }
}

const actions = {
  setTitleBreadcrumb ({ commit } , payload) {
    commit('SET_TITLE_BREADCRUMB', payload)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
